import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class SaveAdShareByEmailHitUserService extends Service {
  constructor({config, repository}) {
    super()
    this._config = config
    this._httpUserRepository = repository
  }
  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  async execute({adId}) {
    const [error] = await this._httpUserRepository.saveAdShareByEmailHit({adId})

    if (error) return Promise.reject(error)
    return Promise.resolve(true)
  }
}
